export enum EnumPopupType {
  BoasVindas = 1,
  Perfil = 2,
  Preferencias = 3,
  Feedback = 4,
}
